import { Inject } from 'inversify-props'
import { ClassificacaoTributaria } from '@/models/fiscal/ClassificacaoTributaria'
import type { ClassificacaoTributariaServiceAdapter } from '../adapter/ClassificacaoTributariaServiceAdapter'

export class FindClassificacaoTributariaUseCase {
	@Inject('ClassificacaoTributariaServiceAdapter')
	private classificacaoTributariaService!: ClassificacaoTributariaServiceAdapter

	findByCodigo = async (codigo: string): Promise<ClassificacaoTributaria> =>
		await this.classificacaoTributariaService.findByCodigo(codigo)

	findAll = async (): Promise<ClassificacaoTributaria[]> =>
		await this.classificacaoTributariaService.findAll()

}